import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo_sem_fundo.png';
import style from "../styles/Navbar.module.css"

interface NavbarProps {}

const Navbar: React.FC<NavbarProps> = () => {
  return (
    <nav className={style.navbar}>
        <div className={style.logo_div}>
          <img src={logo} alt="Logo TBSoftwares" className={style.logo}/>
        </div>
        <div className={style.links}>
        <ul className = {style.nav_links}>
          <li><Link to="/">Início</Link></li>
          <li><Link to="/aboutUs">Sobre Nós</Link></li>
          <li><Link to="/services">Serviços</Link></li>
        </ul>
        </div>
    </nav>
  );
};

export default Navbar;